import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import LeadsCard from "./pages/card";
import { toast } from "react-toastify";
import LeadsList from "./pages/list";
import { Card } from "antd";
import LeadsHeader from "./pages/header";
import AddTypeModal from "./pages/add-type";
import EditTypeModal from "./pages/edit-type";
import DeleteTypeModal from "./pages/delete-type";
import ManageLeadListModal from "../leads-list/manage-list";
import "./styles.scss";

const LeadsManager = () => {
  // STATES
  const [addModalPreview, setAddModalPreview] = useState(false);
  const [manageModalPreview, setManageModalPreview] = useState(false);
  const [editModalPreview, setEditModalPreview] = useState(false);
  const [deleteModalPreview, setMeleteModalPreview] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [searchFilter, setSearchFilter] = useState("");
  const [listFilter, setListFilter] = useState("default");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [state, setState] = useState({
    companies: [],
    items: [
    ],
  });

  // REDUX DATA
  const company = useSelector((state) => state.CompanyReducer.selected_company);
  const user = useSelector((state) => state.UserReducer.profile);

  // CONST VALS
  const history = useHistory();
  const { http } = global.services;
  const isEnterpriseUser = user?.role === "enterprise";

  // HANDLERS
  const addHandler = () => {
    history.push("/leads-manager/create");
  };

  const editModalPreviewHandler = (data) => {
    setSelectedData(data);
    setEditModalPreview(!editModalPreview);
  };

  const deleteModalPreviewHandler = (data) => {
    setSelectedData(data);
    setMeleteModalPreview(!deleteModalPreview);
  };

  const onListDeleteHandler = (id) => {
    if (listFilter === id) {
      setListFilter("default");
    }
  };

  // HELPERS
  const getLeadsHelper = async (paginationParams) => {
    const params = {
      user_company_id: company.id,
      list: listFilter === "default" ? null : listFilter,
      search: searchFilter || null,
      ...paginationParams,
    };
    return await http.get("user-lead", params);
  };

  const initialization = async (initCall) => {
    // TODO: uncomment this when we restrict professional users from accessing enterprise features
    // if (isEnterpriseUser && !company.id) return null;
    if (!company.id) return null;
    const params = {
      limit: 5,
      offset: initCall ? 0 : (page - 1) * 5,
    };
    if (initCall) setPage(1);
    await getLeadsHelper(params)
      .then(({ data }) => {
        const { leads, total_per_type, total } = data;
        setTotal(total);
        let list = [];
        leads.map((val, index) => {
          list.push({
            key: val.id,
            number: index + 1,
            ...val,
          });
        });

        const stats = Object.keys(total_per_type || {}).map((value, index) => ({
          id: total_per_type[value]?.id,
          title: value || "N/A",
          value: total_per_type[value]?.count || 0,
          icon: state.items[index]?.icon || "file",
        }));
        setState({
          ...state,
          companies: list,
          items: stats,
        });
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Something went wrong, please try again later"
        );
      });
  };

  // HOOKS
  useEffect(() => {
    initialization();
  }, [page]);

  // HOOKS
  useEffect(() => {
    initialization(true);
  }, [company, listFilter, searchFilter, isEnterpriseUser]);

  return (
    <React.Fragment>
      <div className="top-header">
        <h2 className="page-title">Leads Manager</h2>
        <div className="action-box">
          <button onClick={() => setAddModalPreview(true)} className="regenerate-toggle">
            Add Communication Type
          </button>
        </div>
      </div>
      <LeadsCard
        data={state.items}
        editHandler={editModalPreviewHandler}
        deleteHandler={deleteModalPreviewHandler}
      />
      <div style={{ padding: "30px 0" }}>
        <Card className="leads-wrapper">
          <div className="title-box">
            <h2>Leads</h2>
            <div className="lead-action-box">
              <button
                className="manage-lead-btn"
                onClick={() => setManageModalPreview(true)}
              >
                Manage Leads List
              </button>
              <button className="add-lead-btn" onClick={addHandler}>
                Add New Lead
              </button>
            </div>
          </div>
          <LeadsHeader
            search={searchFilter}
            setSearch={setSearchFilter}
            listFilter={listFilter}
            setListFilter={setListFilter}
            total={total}
            getLeadsHelper={getLeadsHelper}
          />
          <LeadsList
            company={company}
            page={page}
            setPage={setPage}
            total={total}
            companies={state.companies}
            onReload={initialization}
            deleteHandler={initialization}
          />
        </Card>
      </div>
      <AddTypeModal
        sucessHandler={initialization}
        preview={addModalPreview}
        previewHandler={() => setAddModalPreview(false)}
      />
      <EditTypeModal
        sucessHandler={initialization}
        selectedData={selectedData}
        preview={editModalPreview}
        previewHandler={editModalPreviewHandler}
      />
      <DeleteTypeModal
        sucessHandler={initialization}
        selectedData={selectedData}
        preview={deleteModalPreview}
        previewHandler={deleteModalPreviewHandler}
      />
      <ManageLeadListModal
        onDeleteHandler={onListDeleteHandler}
        preview={manageModalPreview}
        closeHandler={() => setManageModalPreview(false)}
      />
    </React.Fragment>
  );
};

export default LeadsManager;
